module.exports = __webpack_public_path__ + "static/media/facebook-round.f25d0264.svg";